import { AnimeApiFormatAnime } from "./animeApi"
import { API_ANIME } from "./settings"

const fromAnimeApiResponsetoAnime = apiResponse => {
    return AnimeApiFormatAnime(apiResponse?.data);
}
const serviceAnime = (id) => {
    return fetch(`${API_ANIME}${id}`)
        .then(res => res.json())
        .then(fromAnimeApiResponsetoAnime)
}
export default serviceAnime;